import React, { useEffect, useRef, useState } from 'react'
import { ReactComponent as OnewayIcon } from './oneway.svg'
import { ReactComponent as RoundtripIcon } from './roundtrip.svg'

import { ReactComponent as TickIcon } from './Tick.svg'
import { Spacer, Truncate, Button } from '@cleartrip/bento'
import OutsideClickHandler from 'lib/OutsideClickHandler'

import Dropdown from './Dropdown'

const JourneyDropdown = props => {
    const { journeyType, tripTypeHandler } = props
    const [tripType, setTripType] = useState(journeyType === 'R' ? 'Round trip' : 'One way')
    const [clickedItem, setClickedItem] = useState(false)

    useEffect(() => {
        if (journeyType !== tripType) {
            setTripType(journeyType === 'R' ? 'Round trip' : 'One way')
        }
    }, [journeyType])
    const tripTypes = [
        {
            id: 1,
            label: 'One way',
            value: 'oneway',
            selected: true
        },
        {
            id: 2,
            label: 'Round trip',
            value: 'rt',
            selected: false
        }
    ]
    function tripSelect(value, name, returnCrossClick = false) {
        tripTypeHandler(value === 'One way' ? 'O' : 'R')
        setTripType(value)
        setClickedItem(name)
    }
    function toggleFn() {
        setClickedItem(null)
    }
    const tripTypeDropdown = tripTypes.map(item => {
        return (
            <Dropdown.Item
                key={item.id}
                value={item.value}
                className="fs-3 hover:bg-dropdown listItemHover  c-pointer"
                onClick={() => tripSelect(item.label, 'tripType')}
            >
                <div className="flex flex-between">
                    <div className="flex flex-middle">
                        {item.label === tripType ? <TickIcon /> : <Spacer className="ml-11" />}
                        <span className={`${item.label === tripType ? 'ml-5' : ''} dropdown-text fw-500 fs-4 lh-24`}>
                            {item.label}
                        </span>
                    </div>
                </div>
            </Dropdown.Item>
        )
    })
    const getLabel = tripType => {
        return tripType === 'One way' ? (
            <>
                <div className="flex flex-middle">
                    <OnewayIcon />
                    <span className="fw-500 fs-4 ml-2" style={{ lineHeight: '24px' }}>
                        One way
                    </span>
                </div>
            </>
        ) : (
            <>
                <div className="flex flex-middle">
                    <RoundtripIcon />
                    <span className="fw-500 fs-4 ml-2" style={{ lineHeight: '24px' }}>
                        Round trip
                    </span>
                </div>
            </>
        )
    }
    return (
        <div style={{ minWidth: '136px' }}>
            <Dropdown toggle={clickedItem === 'tripType'} toggleFn={toggleFn}>
                <Dropdown.Select
                    className="c-neutral-900"
                    placeHolder="Trip type"
                    label={getLabel(tripType)}
                    width={150}
                    height={40}
                    border={false}
                    style={{ borderStyle: 'hidden' }}
                />
                <Dropdown.Menu>{tripTypeDropdown}</Dropdown.Menu>
            </Dropdown>
        </div>
    )
}

export default JourneyDropdown
